import { render, staticRenderFns } from "./performance-passing-grade.vue?vue&type=template&id=065bbce8"
import script from "./performance-passing-grade.vue?vue&type=script&lang=js"
export * from "./performance-passing-grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports